var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGivingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15625 16.0481L4.99641 19.2482C5.56123 19.7188 6.27318 19.9767 7.0084 19.9767H17.1325C17.8557 19.9767 18.442 19.3904 18.442 18.667C18.442 17.2207 17.2694 16.0481 15.8229 16.0481H8.78443",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87053 14.4765L7.0491 15.6551C7.70002 16.3061 8.75534 16.3061 9.40624 15.6551C10.0572 15.0042 10.0572 13.9489 9.40624 13.298L7.57677 11.4685C6.98737 10.8791 6.18797 10.548 5.35444 10.548H1.15625",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2827 7.41965C10.7313 7.3237 10.7313 6.53206 11.2827 6.43613C13.2806 6.08854 14.8696 4.56683 15.3032 2.58589L15.3365 2.43404C15.4558 1.88901 16.2318 1.88563 16.356 2.42958L16.3962 2.60654C16.8459 4.57815 18.4354 6.087 20.4277 6.43361C20.9819 6.53004 20.9819 7.32573 20.4277 7.42215C18.4354 7.76876 16.8459 9.27761 16.3962 11.2492L16.356 11.4262C16.2318 11.9701 15.4558 11.9668 15.3365 11.4217L15.3032 11.2699C14.8696 9.28893 13.2806 7.76722 11.2827 7.41965Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGivingsIcon);
export default __webpack_public_path__ + "static/media/givingsIcon.6281cbf32356cdee47ac31d9343de440.svg";
export { ForwardRef as ReactComponent };